import logo from '../logo.png';
import '../App.css';
import Navbar from '../components/Navbar';
import GradientAnimation from '../components/GradientAnimation';
import TextAnimation from '../components/TextAnimation';
import FlipCard from '../components/FlipBox';
import HeroAnimation from '../components/HeroAnimation';
import SwiperComponent from '../components/partners';
import Accordion from '../components/Accordion';
import FlickityCarousel from '../components/FlickityCarousel';
import 'flickity/dist/flickity.min.css';
import '../components/flickity.css'; 
import Speakers from '../components/FlickityCarousel';
import sliders from '../bg-kc.webp';
import NewsBox from '../components/BoxNews';
import Countdown from '../components/countdown';
import { SwiperSlide } from "swiper/react";
import sazmanbargh from "../sazmanbargh.png";
import speaker from '../khodam.jpg';
import vidio from '../frame_855-scaled.jpg.webp';
import jsjco  from '../jsjco.webp';
import niroo from '../niroo.png';
import abniroo from '../abniroo.png';
import milad from '../milad.jpg';
import Drbaharlo from '../Drbaharlo.jpg';
import ehsan from '../ehsan.jpg';
import park from '../park.png';
import mamad from '../mohammad.png';
import marashi from '../marashi.jpg';
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import Payment from '../components/Payment';
import FestivalRoadmap from "../components/FestivalRoadmap";
import DEFAULT_ROADMAP from "../data/roadmapSteps";
import { useRoadmapSteps } from '../hooks/useRoadmapSteps';
import { Directions } from '@mui/icons-material';
function Home() {
  const [refrees, setrefrees] = useState([]);
  const [partners, setpartners] = useState([]);
  const [organizers, setOrganizers] = useState([]); // partners_creators from backend
  const [creators, setcreators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { steps: roadmapSteps, loading: roadmapLoading } = useRoadmapSteps();
  const [displayedRoadmapSteps, setDisplayedRoadmapSteps] = useState(DEFAULT_ROADMAP);
  
  useEffect(() => {
    // اگر داده‌های API بارگذاری شد، از آن استفاده کن، وگرنه از داده پیش‌فرض استفاده کن
    if (roadmapSteps && roadmapSteps.length > 0) {
      setDisplayedRoadmapSteps(roadmapSteps);
    }
  }, [roadmapSteps]);
  
  useEffect(() => {
    const fetchrefrees = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/refrees/`);
        setrefrees(response.data);
      } catch (err) {
        console.error(err);
        setError("خطا در بارگذاری !");
      } finally {
        setLoading(false);
      }
    };

    fetchrefrees();
      const fetchpartners = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/partners/`);
        setpartners(response.data);
      } catch (err) {
        console.error(err);
        setError("خطا در بارگذاری !");
      } finally {
        setLoading(false);
      }
    };

    fetchpartners();

    // fetch organizers (partners_creators)
    const fetchOrganizers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/partner-creators/`);
        setOrganizers(response.data);
      } catch (err) {
        console.error(err);
        // don't overwrite general error if others already set
        setError((prev) => prev || "خطا در بارگذاری !");
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizers();

       const fetchcreators = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/creators/`);
        setcreators(response.data);
      } catch (err) {
        console.error(err);
        setError("خطا در بارگذاری !");
      } finally {
        setLoading(false);
      }
    };

    fetchcreators();
  }, []);
  const slidesrefrees = refrees.map(({ pic, name, role }, index) => (
    <SwiperSlide 
      key={index} 
      className="group text-white border-2 border-white/20 rounded-2xl py-8"
    >
      <div className="relative">
        <img
          className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[14.7rem] h-[14.7rem] rounded-md md:rounded-2xl m-2 mx-auto grayscale"
          src={pic}
          alt={name}
        />
        <div className="relative w-full z-30 text-center">
          <p className="text-sm md:text-md font-black mt-2">{name}</p>
          <p className="text-sm md:text-md text-lime-500 font-light">{role}</p>
        </div>
      </div>
    </SwiperSlide>
  ));
  const [gallery, setGallery] = useState([]);
const [galleryLoading, setGalleryLoading] = useState(true);

useEffect(() => {
  const fetchGallery = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/gallery/`);
      setGallery(response.data);
    } catch (err) {
      console.error("Gallery Load Error:", err);
    } finally {
      setGalleryLoading(false);
    }
  };

  fetchGallery();
}, []);
const slidesGallery = gallery.map((item, index) => (
  <SwiperSlide
    key={index}
    className="group text-white border-2 border-white/20 rounded-2xl py-8"
  >
    <div className="relative">
      <img
        className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[14rem] h-[14rem] rounded-xl mx-auto grayscale"
        src={item.image}
        alt={item.title || "gallery"}
      />

      <div className="text-center mt-3">
        <p className="text-sm font-bold">{item.title}</p>
        {item.description && (
          <p className="text-sm text-gray-300">{item.description}</p>
        )}
      </div>
    </div>
  </SwiperSlide>
));

    const slides_partner = partners.map(({ name, logo, order }, index) => (
        <SwiperSlide
          key={index}
          className="opacity-25 hover:opacity-100 transition-opacity pointer"
        >
         <img
            className={`w-full h-auto mt-2`}
            src={logo}
            alt={`Logo ${index + 1}`}
          />
        </SwiperSlide>
      ));
      // slides for organizers (partners_creators)
      const slides_organizers = organizers.map(({ name, logo, order }, index) => (
        <SwiperSlide
          key={index}
          className="opacity-25 hover:opacity-100 transition-opacity pointer"
        >
         <img
            className={`w-full h-auto mt-2`}
            src={logo}
            alt={`Organizer ${index + 1}`}
          />
        </SwiperSlide>
      ));      const slidesCreators = creators.map(({ pic, name, role }, index) => (
        <SwiperSlide key={index} className="group text-white  border-2 border-white/20 rounded-2xl py-8">
          <div className="relative ">
            <img
              className="transition-transform group-hover:scale-105 group-hover:grayscale-0 w-[14.7rem] h-[14.7rem] rounded-md md:rounded-2xl m-2 mx-auto grayscale"
              src={pic} alt={name} />
            
            <div className='relative  w-full z-30 text-center'>
              <p className="text-sm md:text-md font-black mt-2">{name}</p>
              <p className="text-sm md:text-md text-lime-500 font-light">{role}</p>
            </div>
          </div>
        </SwiperSlide>
      ));
      const openPayment = () => {
        window.open(
          "https://panel.aqayepardakht.ir/trustGateway/47704",
          null,
          "width=400,height=600,scrollbars=no,resizable=no"
        );
      };
  return (
    <div className="App">
      <Navbar dir='./' />
      <GradientAnimation />
      <div className='relative'>
      
      <div className='h-[95vh] w-full absolute z-[0] bg-gradient-to-t from-black to-black/30'></div>
      </div>
      <HeroAnimation />
      <div className='h-[4vh]'></div>
      <Countdown 
        timestamp="2024-12-31T23:59:59Z" 
        title="تا شروع ثبت نام" 
        cstyletitle='text-lg md:text-2xl'
        cstylecount='text-2xl md:text-8xl'
        cstyletext='text-md md:text-xl'
      />
    
      
      <div className='h-[8vh] md:h-[15vh]'></div>
      
      <TextAnimation id='text-owners' textStyle='text-3xl sm:text-4xl md:text-5xl' text='حامیان جشنواره'  />
      <SwiperComponent Speed={12000} slidesContent={slides_partner} breakpointsConfig={{240: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
         
          768: {
            slidesPerView: 5,
            spaceBetween: 25,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 35,
          },
          1540: {
            slidesPerView: 10,
            spaceBetween: 45,
          },}}/>
          <div className='h-[15vh]'></div>
      <TextAnimation id='text-news' textStyle='text-3xl sm:text-4xl md:text-5xl' text='اخبار'  />
      <NewsBox />
      <div className='h-[4vh]'></div>
      <FlipCard />
      <div className='h-[4vh]'></div>
      <TextAnimation id='text-owners' textStyle='text-3xl sm:text-4xl md:text-5xl' text='داوران'  />
      {/* <h3 className="text-xl sm:text-2xl p-4 text-white/80">کارون کاپ</h3> */}
      <SwiperComponent Speed={12000} slidesContent={slidesrefrees} breakpointsConfig={{240: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 30,
          },}}/>
      <div className='h-[8vh] md:h-[15vh]'></div>
      <TextAnimation id='text-owners' textStyle='text-3xl sm:text-4xl md:text-5xl' text='سازمان های برگزار کننده'  />
      <SwiperComponent Speed={20000} slidesContent={slides_organizers} breakpointsConfig={{240: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
         
          768: {
            slidesPerView: 5,
            spaceBetween: 25,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 35,
          },
          1540: {
            slidesPerView: 10,
            spaceBetween: 45,
          },}}/>
      <TextAnimation id='text-owners' textStyle='text-3xl sm:text-4xl md:text-5xl' text='مجریان'  />
      {/* <h3 className="text-xl sm:text-2xl p-4 text-white/80">کارون کاپ</h3> */}
      <SwiperComponent Speed={12000} slidesContent={slidesCreators} breakpointsConfig={{240: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 30,
          },}}/>
      <div className='h-20'></div>
      <Accordion />
      <div className='h-[15vh]'></div>
      <FestivalRoadmap steps={displayedRoadmapSteps} initialActiveId={3} theme={{ primary: "#7c3aed", accent: "#06b6d4", bg: "#010204" }} />
<div className='h-[15vh]'></div>


{/* / */}
{/* <a href='gallery' className="text-xl sm:text-4xl p-4 text-white/80">تماشای گالری دوره های پیشین</a> */}
<a href='gallery' className="text-3xl sm:text-4xl md:text-5xl p-4 text-white/80"> گالری </a>
{galleryLoading ? (
  <p className="text-center text-gray-400 py-10">در حال بارگذاری...</p>
) : (
  <SwiperComponent
    Speed={14000}
    slidesContent={slidesGallery}
    breakpointsConfig={{
      240: { slidesPerView: 2, spaceBetween: 20 },
      640: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 3, spaceBetween: 20 },
      1400: { slidesPerView: 5, spaceBetween: 20 },
    }}
  />
)}
<div className="h-[10vh]"></div>
<footer class="w-full bg-[#08080d] border-t border-white/10 pt-10 pb-6 mt-12">
  <div class="max-w-screen-xl mx-auto px-4 md:px-6 lg:px-10" dir="rtl">

  
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">

    
      <div class="text-right">
        <h3 class="text-lime-400 font-semibold tracking-wide mb-3 text-lg">
          ما را دنبال کنید
        </h3>

        <ul class="space-y-2 text-gray-300">
          <li><a href="https://eitaa.com/KarunCup" class="hover:text-lime-400 transition">ایتا</a></li>
          <li><a href="https://www.instagram.com/karuncup/" class="hover:text-lime-400 transition">اینستاگرام</a></li>
          <li><a href="#" class="hover:text-lime-400 transition">لینکدین</a></li>
          <li><a href="#" class="hover:text-lime-400 transition">تلگرام</a></li>
          <li><a href="https://whatsapp.com/channel/0029Vb1ZNv3GufInay4LJ02Y" class="hover:text-lime-400 transition">واتساپ</a></li>
        </ul>

      
      </div>

      <div class="text-right">
        <h3 class="text-lime-400 font-semibold tracking-wide mb-3 text-lg">
          ارتباط با ما
        </h3>

        <ul class="text-gray-300 space-y-3">
          <li>
            <a href="tel:+989909430460" class="hover:text-lime-350 transition" dir="ltr" >
              +98 99 09 430 460
            </a>
          </li>
          <li>
            <a href="mailto:info@karuncup.ir" class="hover:text-lime-350 transition" dir="ltr">
              info@karuncup.ir
            </a>
          </li>
        </ul>
      </div>
      <div class="text-right">
        <h3 class="text-lime-400 font-semibold tracking-wide mb-3 text-lg">
          آدرس برگزاری
        </h3>
        <p class="text-gray-400 leading-7">
          اهواز – گلستان – مرکز همایش‌های بین‌المللی بوستان
        </p>

        <div class="flex flex-wrap gap-4  pt-10 pl-10" dir="ltr">
          <a onClick={openPayment} href="#">
            <img src="https://panel.aqayepardakht.ir/trustlogo/2.svg" class="w-16 h-20 rounded-md shadow-lg shadow-lime-500/20" />
          </a>

          <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=585843&Code=JISv3Q1KFJPOMv42wUvS02nXO22ZTLxp">
            <img referrerpolicy="origin" src="https://trustseal.enamad.ir/logo.aspx?id=585843&Code=JISv3Q1KFJPOMv42wUvS02nXO22ZTLxp"
              class="w-16 h-20 rounded-md shadow-lg shadow-lime-500/20" />
          </a>
        </div>
      </div>

     

    </div>

    
    <div class="w-full border-t border-white/10 my-10"></div>

  
    <div class="flex flex-col sm:flex-row-reverse items-center justify-between text-center sm:text-right gap-4">

      <a href="https://karuncup.ir/" class="flex flex-col sm:flex-row-reverse items-center gap-3">
        <img src={logo} class="h-12 w-12" />
        <span class="text-gray-300 text-md font-medium leading-6">
          جشنواره و مسابقات فناوری‌ های نوین  
          <span class="hidden sm:inline"> در صنعت آب و برق </span>
          <span class="sm:hidden block"> در صنعت آب و برق </span>
        </span>
      </a>

      <span class="text-gray-500 text-sm">
          
        <span>© تمامی حقوق برای شرکت دانش‌بنیان </span> 
            <a href="https://karuncup.ir/" class="hover:text-sky-400 transition ">
               <span>جهان صنعت جنوب </span> 
        </a>
        محفوظ است 
      </span>

    </div>

  </div>
</footer>


    </div>
  );
}

export default Home;
